import React from 'react';
import { useState} from 'react';
import Navigation from '../../Navigation.js';



const Offering = () => {


  const [pagepos, setPagePos] = useState(1);
  const navigationItems = ['Ernährungsberatung','Ernährungstherapie', 'Online' , 'Kostenübernahme','Ablauf','Betr. Gesundheitsförderung', 'Dozenten-und Vortragtätigkeit'];

    return (<div className = 'Offering'>
        <Navigation navigationItems={navigationItems} navnumber={2} pageposition={pagepos}  setPagePosition = {setPagePos}/>
    </div>);
}

export default Offering;